import DataModel from '../../library/proto/data-model'

/**
 * @param {Number} id
 * @param {Boolean} web_distributor_apply_status
 * @param {String} web_app_download_text
 */
export default class WebSystemModel extends DataModel {
  constructor(args) {
    super(args)
    const entity = args || {}
    this.id = entity.id || 0
    this.web_distributor_apply_status =
      entity.web_distributor_apply_status || false
    this.web_app_download_text = entity.web_app_download_text || ''
  }
}
